"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyPipeline = createEmptyPipeline;
const ts_http_runtime_1 = require("@typespec/ts-http-runtime");
/**
 * Creates a totally empty pipeline.
 * Useful for testing or creating a custom one.
 */
function createEmptyPipeline() {
    return (0, ts_http_runtime_1.createEmptyPipeline)();
}
//# sourceMappingURL=pipeline.js.map